export default "__VITE_ASSET__tGR72fXV__"